import { getDisplayPriceCategory, type PriceCategory } from '@hero/core';
import type { Amount, OrderContractElement } from '@hero/schema';
import { buildPreviewFromAmount } from './buildPreviewFromAmount';

export type ReorderPreviewResult = {
  preview: Amount | null;
  category: PriceCategory;
  usingFallback: boolean;
  hasValidPrice: boolean;
};

/**
 * Three-tier reorder price preview:
 *   1. Live calc amount (when load price > 0)
 *   2. Source order's viewer leg amount
 *   3. Empty ("price will be determined later")
 */
export function resolveReorderPreview({
  liveCalcAmount,
  sourceLeg,
}: {
  liveCalcAmount?: Amount | null;
  sourceLeg?: OrderContractElement;
}): ReorderPreviewResult {
  const category = getDisplayPriceCategory(sourceLeg);
  const livePreview = buildPreviewFromAmount(liveCalcAmount ?? undefined);
  const fallbackPreview = buildPreviewFromAmount(sourceLeg?.amount);

  const liveHasValue = (livePreview?.itemsOriginalSubtotal ?? 0) > 0;
  const usingFallback = !liveHasValue && !!fallbackPreview;
  const preview = liveHasValue ? livePreview : fallbackPreview;
  const hasValidPrice = (preview?.total ?? 0) > 0;

  return {
    preview,
    category,
    usingFallback,
    hasValidPrice,
  };
}
